// extracted by mini-css-extract-plugin
module.exports = {"block":"CommonBlock_block__2_Gnh","title":"CommonBlock_title__9U4Lt","text":"CommonBlock_text__3kaiy"};